const NoData = () => {
  return (
    <div className="no-data-container">
      <h1>No Data Available</h1>
    </div>
  );
};

export default NoData;
